// ChattaMedLinkButton — the entity-context "Chatta med Link" action (#301 / B6).
// Styled to echo the round Link FAB: at rest it's just the haloed Link avatar
// (the same teal ring the FAB wears); on hover the "Chatta med Link" label slides
// out to the right. Sits next to an EntityActionMenu (the ordinary actions) so
// the whole row reads as "[Link] ⋮".
import React from 'react';
import { LinkAvatar } from '@/components/icons/LinkAvatar';

export const ChattaMedLinkButton: React.FC<{
    onClick: () => void;
    label?: string;
    className?: string;
}> = ({ onClick, label = 'Chatta med Link', className = '' }) => (
    <button
        type="button"
        onClick={onClick}
        title={label}
        aria-label={label}
        className={`group inline-flex items-center rounded-full border border-[#1A4D4F]/20 bg-white p-1 text-sm font-semibold text-[#1A4D4F] shadow-sm transition-all hover:border-[#1A4D4F]/40 hover:bg-[#1A4D4F]/5 hover:shadow active:scale-95 ${className}`}
    >
        <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-white shadow-[0_0_0_2px_rgba(26,77,79,0.18)]">
            <LinkAvatar className="h-4 w-4" />
        </span>
        {/* Collapsed to zero width at rest; slides open on hover/focus. */}
        <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-200 group-hover:max-w-[12rem] group-hover:pl-2 group-hover:pr-2 group-hover:opacity-100 group-focus-visible:max-w-[12rem] group-focus-visible:pl-2 group-focus-visible:pr-2 group-focus-visible:opacity-100">
            {label}
        </span>
    </button>
);

export default ChattaMedLinkButton;
